import axios from 'axios'
// import store from '@/store/'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  // const pPort = store.getters.theApis.fdc.sitePort
  // const pUrl = store.getters.theApis.fdc.siteIp
  // return {
  //   // url: 'http://'.concat(env ? pUrl : 'localhost'),
  //   url: env ? ((process.env.VUE_APP_HTTPS_ENABLE === 'true' ? 'https://' : 'http://') + pUrl) : 'http://localhost',
  //   port: ':'.concat(env ? pPort : '15014'),
  //   service: '/fdc/ars'
  // }
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004'),
    service: '/fdc/ars'
  }
}

export default {
  getFaultActionHistory: async (payload) => {
    const url = config().url.concat(config().port, config().service, '/fault-action/list')
    const result = await axios
      .get(url, { params: payload })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.error(err)
      })
    return result
  }
}
